(() => {
  /* Makers marquee — only runs while on screen; pause button for everyone */
  document.querySelectorAll('[data-ciao-makers]').forEach((section) => {
    const toggle = section.querySelector('[data-ciao-makers-toggle]');
    if (toggle) {
      toggle.addEventListener('click', () => {
        const paused = section.classList.toggle('is-paused');
        toggle.setAttribute('aria-pressed', String(paused));
      });
    }
    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => section.classList.toggle('is-visible', entry.isIntersecting));
    }).observe(section);
  });

  /* Newsletter: postcard mirrors the email and gets stamped on submit */
  document.querySelectorAll('[data-ciao-letter]').forEach((form) => {
    const card = form.querySelector('[data-ciao-postcard]');
    const to = form.querySelector('[data-postcard-to]');
    const email = form.querySelector('[data-letter-email]');
    const day = form.querySelector('[data-postmark-day]');
    const year = form.querySelector('[data-postmark-year]');

    const now = new Date();
    if (day) day.textContent = now.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' }).toUpperCase();
    if (year) year.textContent = String(now.getFullYear());

    if (email && to) {
      const original = to.textContent;
      email.addEventListener('input', () => {
        to.textContent = email.value.trim() || original;
      });
    }

    form.addEventListener('submit', () => {
      if (card) card.classList.add('is-sent');
    });
  });
})();
